import React from 'react';
import { Link } from 'react-router-dom';
import { collectionPieces } from '../utils/mockData';
import { useContent, resolveAsset } from '../contexts/ContentContext';
import ProductGrid from './ProductGrid';

const mapDb = (p) => ({
  id: p.id,
  type: p.type,
  name: p.name,
  description: p.description,
  technique: p.embroidery || 'Bespoke',
  material: p.fabric || 'Pure Silk',
  hours: 200,
  image: resolveAsset(p.image),
});

const Collection = ({ onInquire }) => {
  const { products, content } = useContent();
  const section = content['home.collection'] || {};

  const archive = products.filter((p) => p.type === 'archive');
  // Featured first, then non-featured fill — every uploaded piece is reachable (capped at 8).
  const featured = archive.filter((p) => p.featured).map(mapDb);
  const rest = archive.filter((p) => !p.featured).map(mapDb);
  const ordered = [...featured, ...rest];
  const items = (ordered.length ? ordered : collectionPieces).slice(0, 8);

  return (
    <section id="collection" className="section-padding" style={styles.section}>
      <div className="luxury-container">
        <div style={styles.sectionHeader}>
          <p style={styles.sectionLabel}>{section.eyebrow || 'The Archives'}</p>
          <h2 className="heading-1">{section.title || 'Timeless Creations'}</h2>
          <p className="body-large" style={styles.sectionDescription}>
            {section.description || 'Each piece tells a story of heritage, crafted with devotion over hundreds of hours'}
          </p>
        </div>

        <ProductGrid
          items={items}
          variant="collection"
          onInquire={onInquire}
          testIdPrefix="collection"
        />

        <div style={styles.ctaWrap}>
          <Link to="/archive?type=archive" className="btn-secondary" data-testid="collection-view-all">
            {section.viewAllText || 'View Heritage Collection'}
          </Link>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: 'var(--bg-secondary)',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  sectionLabel: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '16px',
  },
  sectionDescription: {
    maxWidth: '600px',
    margin: '16px auto 0',
  },
  ctaWrap: {
    marginTop: '32px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export default Collection;
